import {BaseFactory} from "../../../../infrastructure/factories/base-factory";
import {LocaleApiModel} from "../../models/locale/locale.api-model";
import {LocaleDomainModel} from "../../models/locale/locale.domain-model";
import {LanguageDomainModel} from "../../models/language/language.domain-model";
import {USER_COUNTRY_CONFIG} from "../../../../core/app/consts/user-country-config";
import {UserCountryModel} from "../../models/user-country/user-country.model";
import {BaseApiRequestParams} from "../../../../infrastructure/models/params/base-api-request-params";

export class LocaleFactory extends BaseFactory {
  static injectables = [...BaseFactory.injectables];

  createApiModel(apiModel, cultureName: String): LocaleApiModel {
    const model: LocaleApiModel = new LocaleApiModel(apiModel, cultureName);

    return model
  }

  createDomainModel(apiModel: LocaleApiModel, language: LanguageDomainModel): LocaleDomainModel {
    const userCountryConfig = USER_COUNTRY_CONFIG[apiModel.userCountryId];
    const userCountryModel = userCountryConfig ? new UserCountryModel(userCountryConfig, apiModel.userCountryId) : null;

    const domain: LocaleDomainModel = new LocaleDomainModel(apiModel, language, userCountryModel);

    return domain;
  }

  createResponse(apiModel, request: BaseApiRequestParams){
    const response: LocaleApiModel = new LocaleApiModel(apiModel, request?.requestParams?.cultureName);

    return response
  }
}

